import { MobiDocument } from './MobiDocument';

export class PaletteDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private intitule: string;
    private code: string;
    private presence: string;
    private typePointage: string;
    private type_palette: string;
    private couleur: number;
    private archive: boolean;
    //Attributs for Vue
    private couleurHex: string;

    constructor(palette: any) {
        super();
        if (Object.keys(palette).length === 0)
            palette = {
                "_id": "PaletteDocument_-32",
                "code": "PR",
                "intitule": "Présence",
                "typePointage": "REEL",
                "presence": "PRESENCE",
                "type_palette": "ENFANT_AN",
                "couleur": 13260,
                "archive": false,
                "typedoc": "PaletteDocument",
                "id": -32
            }
        this._id = palette._id;
        this._rev = palette._rev;
        this.id = palette.id;
        this.intitule = palette.intitule;
        this.code = palette.code;
        this.presence = palette.presence;
        this.typePointage = palette.typePointage;
        this.type_palette = palette.type_palette;
        this.couleur = palette.couleur;
        this.couleurHex = "#00827a";
        this.archive = palette.archive;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getIntitule(): string {
        return this.intitule;
    }

    public setIntitule(intitule: string): void {
        this.intitule = intitule;
    }

    public getCode(): string {
        return this.code;
    }

    public setCode(code: string): void {
        this.code = code;
    }

    public getPresence(): string {
        return this.presence;
    }

    public setPresence(presence: string): void {
        this.presence = presence;
    }

    public getTypePointage(): string {
        return this.typePointage;
    }

    public setTypePointage(typePointage: string): void {
        this.typePointage = typePointage;
    }

    public getType_palette(): string {
        return this.type_palette;
    }

    public setType_palette(type_palette: string): void {
        this.type_palette = type_palette;
    }

    public getCouleur(): number {
        return this.couleur;
    }

    public setCouleur(couleur: number): void {
        this.couleur = couleur;
    }

    public getCouleurHex(): string {
        return this.couleurHex;
    }

    public setCouleurHex(couleurHex: string): void {
        this.couleurHex = couleurHex;
    }

    public getArchive(): boolean {
        return this.archive
    }
    public setArchive(archive: boolean): void {
        this.archive = archive
    }
}